module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/public-preview-desktop.svg"